module.exports = __webpack_public_path__ + "assets/img/8_1749_big.dc98663c.jpg";